// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumb_breadcrumbs__d0Ngk"};